import { intComma } from 'humanize-plus'
import React,
{ Component } from 'react'
import { connect } from 'react-redux'

import { Button } from '@driftt/dds'
import { faTrash } from '@driftt/dds.icons/dist/light/faTrash'
import {
  Div,
  Input,
  Span 
} from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { filterSegmentType } from 'modules/segments/actions'

import { getSegmentTypesAvailableForFiltering } from '../constants/SegmentTypes'

import './style.css'

const mapStateToProps = (state) => ({
  selectedSegments: state.__CRM.segments.selectedSegments,
  filteredSegmentType: state.__CRM.segments.filteredSegmentType,
})

const mapDispatchToProps = (dispatch) => ({ onFilterSegmentType: (type) => dispatch(filterSegmentType(type)), })

class SegmentControls extends Component {
  handleSearch = (e) => {
    const { onSearch } = this.props
    onSearch(e)
  };

  render() {
    const {
      totalSegments,
      onSelectAll,
      onDelete,
      onFilterSegmentType,
      selectedSegments,
      filteredSegmentType,
    } = this.props

    const allSegmentsDropdownOption = {
      value: 'ALL',
      label: 'All segments',
      title: `All segments (${totalSegments})`,
    }
    const segmentTypeDropdownOptions = getSegmentTypesAvailableForFiltering().map((segmentType) => ({
      value: segmentType.key,
      label: segmentType.displayNameFullPlural,
      title: `${segmentType.displayNameFullPlural} (${totalSegments})`,
    }))

    const allDropdownOptions = [
      allSegmentsDropdownOption,
      ...segmentTypeDropdownOptions,
    ]

    const selectValue = allDropdownOptions.filter(({ value }) => value === filteredSegmentType)

    const renderOption = (option) => {
      return <div> {option.label}</div>
    }

    return (
      <Div className='segments-controls'>
        {selectedSegments.length === 0 && (
          <Select
            className="segments-controls--filter-type-select"
            value={selectValue}
            onChange={(value) => {
              onFilterSegmentType(value.value)
            }}
            clearable={false}
            searchable={false}
            labelKey='title'
            options={allDropdownOptions}
            optionRenderer={renderOption}
          />
        )}
        {selectedSegments.length > 0 && (
          <Div className='segments-controls--text-controls'>
            <Div className='segments-controls--text-controls--selected'>
              <Span>{`${intComma(selectedSegments.length)} segments selected`}
              </Span>
              <Span className='link' onClick={() => onSelectAll(false)}>
                Clear
              </Span>
            </Div>
            <Div className='segments-controls--text-controls--buttons'>
              <Button variant='tertiary' onClick={() => onDelete()}>
                <Button.Icon icon={faTrash}/>
                Delete Segments
              </Button>
            </Div>
          </Div>
        )}
        <Input
          placeholder='Search segment names'
          onChange={this.handleSearch}
          type='search'
        />
      </Div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SegmentControls)
